/** Published Chrome Web Store extension id (client + server safe). */
export const CHROME_EXTENSION_ID = "dmgikpnmicdemepagiabhmoongkgdeil";
